export default "__VITE_ASSET__BNG4qx1$__"